import { CatalogApi } from "../../../api/catalog";
import { throwErrorToastAsync } from "../../../services/throwErrorToast";
import { setCatalogOrganization, setLoadingCatalogOrganization } from "../../reducers/catalog/catalog";
import { AppThunk } from "../../store";

const api = new CatalogApi();

export const fetchOrganizationSelector = (): AppThunk => async (dispatch) => {
    try {
        dispatch(setLoadingCatalogOrganization(true));
        const response = await api.getOrganizationSelector();
        dispatch(setCatalogOrganization(response));
    } catch (error: any) {
        throwErrorToastAsync(error);
    } finally {
        dispatch(setLoadingCatalogOrganization(false));
    }
};
